const canAuditTrailRead = { key: 'canAuditTrailRead', service: 'audit', resource: 'event', action: 'read' }

export {
  canAuditTrailRead
}
